(function() {
    'use strict';
    angular
        .module('editorApp')
        .factory('Gallery', Gallery)
        .factory('VerifyCode', VerifyCode)
        .factory('Customer', Customer)

        .factory('Folder', Folder);

    Gallery.$inject = ['$resource'];
    Folder.$inject = ['$resource'];
    Customer.$inject = ['$resource'];
    VerifyCode.$inject = ['$resource', 'DateUtils']

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/customers/:path/:id';

        return $resource(resourceUrl, {}, {
            "getLocation":{
                method:"GET",
                params:{
                    path:"getLocation"
                }
            },
            "addLocation":{
                method:"POST",
                params:{
                    path:"addLocation"
                }
            },
            "updateLocation":{
                method:"POST",
                params:{
                    path:"updateLocation"
                }
            },
            "setDefaultLocation":{
                method:"GET",
                params:{
                    path:"setDefaultLocation"
                }
            },
            "removeLocation":{
                method:"GET",
                params:{
                    path:"removeLocation"
                }
            },
            "current":{
                method:"GET",
                params:{
                    path:"current"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'setPhone': {
                method: 'GET',
                params: {
                    path:"setPhone"
                }
            },
            "register":{
                method:"POST",
                params:{
                    path:"register"
                }
            },
            "register2":{
                method:"POST",
                params:{
                    path:"register2"
                }
            },

            "checkPhone":{
                method:"GET",
                params:{
                    path:"checkPhone"
                }
            },
            "checkPassword":{
                method:"GET",
                params:{
                    path:"checkPassword"
                }
            },
            "changePassword":{
                method:"POST",
                params:{
                    path:"changePassword"
                }
            },
            "authenticate":{
                method:"GET",
                params:{
                    path:"authenticate"
                }
            }
        });
    }


    function VerifyCode ($resource, DateUtils){
        var resourceUrl = 'manager'+ '/api/verify-codes/:path/:id';
        return $resource(resourceUrl,{},{
            "getVerifyCode":{
                method:"GET",
                params:{
                    path:"getVerifyCode"
                }
            },
            "check":{
                method:"GET",
                params:{
                    path:"check"
                }
            }
        })
    }

    function Gallery ($resource) {
        var resourceUrl =  'service/' + 'api/gallery/:store/:path/:id';

        return $resource(resourceUrl, {}, {
            'detectFaces': {
                method: 'GET',
                params: {
                    path: 'detectFaces'
                },
            },
            'unUsed': {
                method: 'POST',
                params: {
                    path: 'unUsed'
                },
            },
            'update': {
                method: 'GET',
                params: {
                    path: 'update'
                },
            },
            'batchDelete':{
                method: 'POST',
                params: {
                    path: 'batchDelete'
                }
            },
            "delete":{
                method:"DELETE"
            },
            'get': {
                method: 'GET',
                params: {
                    path: 'all'
                }
            },
            'getPage': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'upload':{
                method:'GET',
                params:{
                    path:'upload'
                }
            },
            'getOne':{
                method:'GET',
                params:{
                    path:'getOne'
                }
            },
            'updateNum':{
                method:'POST'
            },
            'moveFolder': {
                method: "GET",
                params: {
                    path: "moveFolder"
                },
            },
            'all': {
                method: "POST",
                params: {
                    path: "all"
                }
            },
            "storeByCondition": {
                method: "POST",
                params: {
                    path: "byCondition",
                    store:"store"
                }
            }
        });
    }

    function Folder($resource) {
        var resourceUrl = 'service/' + 'api/folders/:store/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'delete': {
                method: 'DELETE'
            },
            'batchDelete': {
                method: 'GET',
                params: {
                    path: "batchDelete"
                }
            },
            "storeGetAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition",
                    store:"store"
                }
            },
            "getAllByConditionAndQuantity": {
                method: "GET",
                params: {
                    path: "getAllByConditionAndQuantity"
                },
            },
        });
    }
})();
